import PhotoGrayIcon from '@assets/images/common/image_dummy.svg';
import { SupportServiceTag } from '@src/api/types/supportServiceTag';
import { COMPANY_URL } from '@src/routes/company';
import Tag from '@src/ui/elements/Company/Tag';
import generateUrlWithParams from '@src/utils/generateUrlWithParams';
import React from 'react';
import { Link } from 'react-router-dom';

interface SupportServicesItemProps {
  to: string;
  title: string;
  content: string;
  category: string;
  categorySlug?: string;
  tags: SupportServiceTag[];
  thumbnail: string;
}

const SupportServicesItem: React.FC<SupportServicesItemProps> = ({
  to,
  title,
  content,
  category,
  categorySlug,
  tags,
  thumbnail,
}) => {
  return (
    <article>
      <div className='flex items-start gap-6 transition-opacity hover:opacity-80 md:flex-col'>
        <div className='w-[300px] flex-[0_0_auto] md:w-full'>
          <Link
            to={to}
            data-testid='support-service-link-thumbnail'
          >
            <img
              className='aspect-[300/168] size-full object-contain'
              src={thumbnail}
              alt=''
              width={300}
              height={168}
              loading='lazy'
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = PhotoGrayIcon;
              }}
            />
          </Link>
        </div>
        <div className='flex w-full flex-col'>
          <div className='flex items-center gap-4'>
            <Link
              to={generateUrlWithParams(COMPANY_URL.SUPPORT_SERVICES, {
                category_slug: categorySlug || '',
              })}
              className='border-b-2 border-primary-500 py-1 text-xs text-primary'
              data-testid='support-service-link-category'
            >
              {category}
            </Link>
          </div>
          <div>
            <Link
              to={to}
              data-testid='support-service-link-title'
            >
              <h2 className='order-2 mt-4 line-clamp-1 break-all text-xl font-semibold'>{title}</h2>
            </Link>
          </div>
          <div className='order-3 mt-2 line-clamp-2 break-all text-sm leading-7'>{content}</div>
          <ul className='order-4 mt-3 flex flex-wrap gap-2 pt-1'>
            {tags.map((tag, index) => (
              <Tag
                key={index}
                to={generateUrlWithParams(COMPANY_URL.SUPPORT_SERVICES, {
                  tag_slug: tag.slug || '',
                })}
                label={tag.name}
              />
            ))}
          </ul>
        </div>
      </div>
    </article>
  );
};

export default SupportServicesItem;
